import React from "react";
import { Button } from "@material-ui/core";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";

interface SMAButtonProps {
  onAction?: () => void;
  className?: string;
  disabled?: boolean;
  variant: "text" | "outlined" | "contained";
  color: "primary" | "secondary";
}

const theme = createMuiTheme({
  palette: {
    action: {
      disabledBackground: "#F4B82730",
      disabled: "#00152E",
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: "6px",
        textTransform: "none",
        fontFamily: "Lato",
        fontSize: "18px",
        fontWeight: 400,
        padding: "10px 20px 12px",
      },
      containedPrimary: {
        backgroundColor: "#F4B827",
        color: "#00152E",

        "&:hover": {
          backgroundColor: "#d5d5d5",
          color: "#00152E",
        },
      },
      containedSecondary: {
        backgroundColor: "#02489D",
        color: "#fff",

        "&:hover": {
          backgroundColor: "#02489D",
        },

        "&.Mui-disabled": {
          backgroundColor: "#02489D",
          color: "#fff",
          opacity: 0.5,
        },
      },
      textPrimary: {
        color: "#F4B827",
        padding: "10px 20px 12px",

        "&:hover": {
          backgroundColor: "transparent",
        },
      },
    },
  },
});

const SMAButton: React.FC<SMAButtonProps> = (props) => {
  const { onAction, ...rest } = props;

  return (
    <ThemeProvider theme={theme}>
      <Button onClick={onAction} {...rest}>
        {props.children}
      </Button>
    </ThemeProvider>
  );
};

export default SMAButton;
